import { render } from "./ParticipantCard.vue?vue&type=template&id=68cc0662&scoped=true"
import script from "./ParticipantCard.vue?vue&type=script&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&lang=js"

import "./ParticipantCard.vue?vue&type=style&index=0&id=68cc0662&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cc0662"]])

export default __exports__